<template>
    <footer>
        <div class="top">
            <LogoComponent :white="true" :styles="{ width: '180px', margin: '1rem auto' }" />

            <p class="hashtag">
                #عمو_خالد #ستور
            </p>

            <SocialMediaComponent />
        </div>

        <div class="middle">
            <FooterLinksComponent />
        </div>

        <div class="end copyright">
            <div className="copyright-logo">
                <img className="w-100 h-100" src='@/assets/copyright/company-logo.png' alt="" />
            </div>
            <p>حقوق النشر © 2025 لشركة Easy Tech . كل الحقوق محفوظة.</p>
        </div>

    </footer>
</template>
<script>
import LogoComponent from '../Logo/LogoComponent.vue';
import FooterLinksComponent from './FooterLinksComponent.vue';
import SocialMediaComponent from './SocialMediaComponent.vue';

export default {
    name: 'FooterComponent',
    components: {
        LogoComponent,
        SocialMediaComponent,
        FooterLinksComponent
    }
}
</script>
<style scoped>
footer {
    min-height: 70vh;
    position: relative;
    background: #2c3e50;
    margin-top: 2rem;
    padding: 1.5rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

footer::after {
    content: '';
    position: absolute;
    right: 0;
    left: -0%;
    top: 100%;
    z-index: 10;
    display: block;
    height: 50px;
    background-size: 50px 100%;
    background-image: linear-gradient(135deg, #2c3e50 25%, transparent 25%), linear-gradient(225deg, #2c3e50 25%, transparent 25%);
    background-position: 0 0;
    top: 0px;
    transform: translateY(-100%) rotate(180deg);
}

p.hashtag {
    font-size: 2rem;
    color: transparent;
    -webkit-text-stroke: 1.4px #81BFDA;
    /* Border size and color */
    opacity: 0.5;
}

.copyright {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    direction: ltr;
    padding-bottom: 10px;
}

.copyright .copyright-logo {
    width: 140px;
    height: 30px;
}

.copyright p {
    color: #FFFFFFB2;
    padding: 0;
    margin: 0;
    margin-left: 10px;
}

@media(max-width:767px) {
    .copyright .copyright-logo {
        width: 50px;
        height: unset;
    }

    .copyright p {
        font-size: 10px;
    }
}
</style>